const productDetailsPage = {
    ProductDetailsPage: {
        baseStyle: ({headerSize, headerSizeCollapsed, isHeaderExpanded}) => ({
            container: {
                w: '100%',
                h: 'auto',
                ...(isHeaderExpanded && {
                    pt: {
                        base: `${headerSize.base}px`,
                        sm: `${headerSize.sm}px`,
                        md: `${headerSize.md}px`,
                        lg: `${headerSize.lg}px`,
                        xl: `${headerSize.xl}px`,
                        '2xl': `${headerSize['2xl']}px`,
                    },
                }),
                ...(!isHeaderExpanded && {
                    pt: {
                        base: `${headerSizeCollapsed.base}px`,
                        sm: `${headerSizeCollapsed.sm}px`,
                        md: `${headerSizeCollapsed.md}px`,
                        lg: `${headerSizeCollapsed.lg}px`,
                        xl: `${headerSizeCollapsed.xl}px`,
                        '2xl': `${headerSizeCollapsed['2xl']}px`,
                    },
                }),
                alignItems: 'flex-start',
            },
        }),
    },
}

export default productDetailsPage
